/**
 * Suspense fallback for route chunks.
 *
 * Rarely seen: warmed chunks render synchronously, and startTransition keeps
 * the previous page mounted during a navigation. It shows up on a hard load of
 * a deep link, where there is no previous page to keep.
 *
 * The 250ms delay is deliberate. A warm or near-warm chunk resolves faster than
 * that, and flashing a loader for 80ms reads as a glitch — worse than showing
 * nothing at all.
 */

import { useEffect, useState } from "react";
import InfiniteLoader from "./InfiniteLoader";

const RouteFallback: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), 250);
    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div style={{ minHeight: "60vh" }} aria-busy="true">
      <InfiniteLoader />
    </div>
  );
};

export default RouteFallback;
